/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./memetownIndex.vue?vue&type=template&id=27b3ff0a&scoped=true"
import script from "./memetownIndex.vue?vue&type=script&lang=js"
export * from "./memetownIndex.vue?vue&type=script&lang=js"
import style0 from "./memetownIndex.vue?vue&type=style&index=0&id=27b3ff0a&prod&lang=scss"
import style1 from "./memetownIndex.vue?vue&type=style&index=1&id=27b3ff0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b3ff0a",
  null
  
)

export default component.exports